export default __webpack_public_path__ + "static/mealpreppro-protein-real-9b31be969559830bda3459a82dfb66dc.mp4";